export enum PageType {
  DRIVER_DATA = 'driver_data',
  TIME_ENTRIES = 'time_entries',
  ABSENCES = 'absences',
  USERS = 'users',
  FORUM = 'forum',
  ISSUES = 'issues',
  INFRINGEMENTS = 'infringements',
  VEHICLES = 'vehicles',
  FORM_CREATOR = 'form_creator',
  WORK_PERIODS = 'work_periods',
  CONFIRM_HOURS = 'confirm_hours',
  DRIVERS_HANDBOOK = 'drivers_handbook',
  CHECKLISTS = 'checklists',
  SALARY_BASES = 'salary_bases',
  EXPORTS = 'exports',
}
